"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var am4charts = _interopRequireWildcard(require("@amcharts/amcharts4/charts"));

var am4core = _interopRequireWildcard(require("@amcharts/amcharts4/core"));

var _components = require("@theme-ui/components");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _amChartsApi = _interopRequireDefault(require("../../amChartsApi/amChartsApi"));

var _useAmChart = _interopRequireDefault(require("../../hooks/useAmChart"));

var _useAmChartData2 = _interopRequireDefault(require("../../hooks/useAmChartData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var updateChartColor = function updateChartColor(chart, id, active) {
  var columns = chart.series.getIndex(0).columns.values;
  var column = columns.find(function (col) {
    return col.dataItem.dataContext.dataContext.id === id;
  });

  if (!column) {
    return;
  }

  column.isActive = active;
};

var createZeroValueBox = function createZeroValueBox(rootContainer, label) {
  var container = rootContainer.createChild(am4core.Container);
  container.height = 28;
  container.width = am4core.percent(100);
  container.marginTop = 8;
  var rec = container.createChild(am4core.RoundedRectangle);
  rec.height = am4core.percent(100);
  rec.cornerRadius(8, 8, 8, 8);
  rec.width = am4core.percent(100);
  rec.fill = am4core.color('#eceff1');
  var labelContainer = container.createChild(am4core.Container);
  labelContainer.width = am4core.percent(100);
  labelContainer.height = am4core.percent(100);
  labelContainer.padding(8, 8, 8, 8);
  labelContainer.layout = 'horizontal';
  var labelEl = labelContainer.createChild(am4core.Label);
  labelEl.height = am4core.percent(100);
  labelEl.text = label;
  labelEl.wrap = true;
  labelEl.truncate = true;
  labelEl.fullWords = false;
  labelEl.ellipses = '...';
  labelEl.maxWidth = am4core.percent(100);
  labelEl.width = am4core.percent(100);
  var labelState = labelContainer.createChild(am4core.Label);
  labelState.text = 'Not selected';
  labelState.align = 'right';
  labelState.marginLeft = 8;
  labelState.fill = am4core.color('rgba(0, 0, 0, 0.3)');
  labelState.fontFamily = 'PTSans';
  labelState.element.addStyle({
    'font-style': 'italic'
  });
};

var FilterTreeMapChart = function FilterTreeMapChart(_ref) {
  var chartId = _ref.chartId,
      data = _ref.data,
      onClickFilter = _ref.onClickFilter,
      loading = _ref.loading,
      config = _ref.config,
      props = _objectWithoutPropertiesLoose(_ref, ["chartId", "data", "onClickFilter", "loading", "config"]);

  var context = (0, _themeUi.useThemeUI)();
  var theme = (0, _react.useRef)(context.theme);
  var chart = (0, _useAmChart["default"])(chartId, am4charts.TreeMap);
  (0, _react.useEffect)(function () {
    if (!chart || !data) {
      return;
    }

    var containerId = 'zero-values-container';
    var containerEl = chart.children.values.find(function (child) {
      return child.id === containerId;
    });

    if (containerEl) {
      containerEl.dispose();
    }

    var newContainer = chart.createChild(am4core.Container);
    newContainer.id = containerId;
    newContainer.layout = 'vertical';
    newContainer.width = am4core.percent(100);
    var emptyDataItems = data.filter(function (item) {
      return item.value === 0;
    });
    emptyDataItems.forEach(function (item) {
      createZeroValueBox(newContainer, item.label);
    });
  }, [chart, data]);
  var onDataChange = (0, _react.useCallback)(function (_ref2) {
    var newData = _ref2.newData,
        removedData = _ref2.removedData,
        updatedData = _ref2.updatedData;
    var requestChartRedraw = false;
    newData.forEach(function (dataItem) {
      chart.addData(dataItem);
    });

    if (removedData.length > 0) {
      requestChartRedraw = true;
    }

    updatedData.forEach(function (dataItem) {
      var result = mutateDataItem(dataItem["new"].id, dataItem.key, dataItem.old[dataItem.key], dataItem["new"][dataItem.key]);

      if (!result) {
        requestChartRedraw = true;
      }
    });

    if (requestChartRedraw) {
      invalidateData();
    }
  }, [chart, invalidateData, mutateDataItem]);

  var _useAmChartData = (0, _useAmChartData2["default"])(chart, data, onDataChange),
      invalidateData = _useAmChartData.invalidateData;

  var mutateDataItem = (0, _react.useCallback)(function (dataItemId, dataKey, oldVal, newVal) {
    var chartDataItem = chart.data.find(function (dataItem) {
      return dataItem.id === dataItemId;
    });

    if (!chartDataItem) {
      return false;
    }

    switch (dataKey) {
      case 'active':
        chartDataItem.active = newVal;
        updateChartColor(chart, dataItemId, newVal);
        return true;

      case 'value':
        return false;

      default:
        return false;
    }
  }, [chart]);
  (0, _react.useLayoutEffect)(function () {
    if (!chart) {
      return;
    }

    var columnTemplate = chart.seriesTemplates.template.columns.template;
    var columnToggledEvent = columnTemplate.events.on('hit', function (ev) {
      if (!ev.target.dataItem) {
        return;
      }

      onClickFilter(ev.target.dataItem.dataContext.dataContext.id);
    });
    return function () {
      columnToggledEvent.dispose();
    };
  }, [chart, onClickFilter]);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    chart.maxLevels = 1;
    chart.zoomable = false;
    chart.dataFields.value = 'value';
    chart.dataFields.name = 'name';
    chart.paddingTop = 0;
    chart.paddingLeft = 0;
    chart.paddingBottom = 24;
    chart.paddingRight = 0;
    var bgColor = new am4core.InterfaceColorSet().getFor('background');
    chart.colors.list = [am4core.color(bgColor)];
    chart.colors.reuse = true;
    var seriesTemplate = chart.seriesTemplates.create('0');
    var columnTemplate = seriesTemplate.columns.template;

    _amChartsApi["default"].tooltip(seriesTemplate.tooltip).setDefaultStyles(theme.current);

    seriesTemplate.tooltip.animationDuration = 0;
    columnTemplate.tooltipText = config.tooltipText;
    var columnMargin = 4;
    var strokeWidth = 1;
    var strokeGap = strokeWidth / 2;
    columnTemplate.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    columnTemplate.focusable = true;
    columnTemplate.column.cornerRadius(8, 8, 8, 8);
    columnTemplate.fillOpacity = 1;
    columnTemplate.column.adapter.add('paddingTop', function (padding, target) {
      if (target.parent.y === 0) {
        return 0 + strokeGap;
      }

      return columnMargin + strokeGap;
    });
    columnTemplate.column.adapter.add('paddingLeft', function (padding, target) {
      if (target.parent.x === 0) {
        return 0 + strokeGap;
      }

      return columnMargin + strokeGap;
    });
    columnTemplate.column.adapter.add('paddingRight', function (padding, target) {
      if (target.parent.x + target.parent.width === target.parent.parent.maxWidth) {
        return 0 + strokeGap;
      }

      return columnMargin + strokeGap;
    });
    columnTemplate.column.adapter.add('paddingBottom', function (padding, target) {
      if (target.parent.y + target.parent.height === target.parent.parent.maxHeight) {
        return 0 + strokeGap;
      }

      return columnMargin + strokeGap;
    });
    columnTemplate.strokeWidth = strokeWidth;
    columnTemplate.strokeOpacity = 1;
    columnTemplate.stroke = am4core.color(theme.current.colors.neutral[2]);
    columnTemplate.clickable = true;
    columnTemplate.togglable = false;
    columnTemplate.propertyFields.isActive = 'active';
    var activeState = columnTemplate.states.create('active');
    activeState.properties.strokeWidth = 0;
    activeState.properties.fill = am4core.color(theme.current.colors.secondaryPressed);
    var hoverActiveState = columnTemplate.states.create('hoverActive');
    hoverActiveState.properties.fill = am4core.color(theme.current.colors.secondary);
    hoverActiveState.properties.strokeWidth = 0;
    var hoverState = columnTemplate.states.create('hover');
    hoverState.properties.stroke = am4core.color(theme.current.colors.secondary);
    var labelBullet = seriesTemplate.bullets.push(new am4charts.LabelBullet());
    labelBullet.cursorOverStyle = am4core.MouseCursorStyle.pointer;
    labelBullet.focusable = true;
    labelBullet.clickable = true;
    labelBullet.adapter.add('hidden', function (visible, target) {
      if (target.maxWidth < 40) {
        return true;
      } else if (target.maxHeight < 20) {
        return true;
      } else if (target.dataItem.value === 0) {
        return true;
      }

      return false;
    });
    labelBullet.adapter.add('dx', function (dx, target) {
      if (target.x === 0) {
        return -columnMargin;
      }

      return 0;
    });
    labelBullet.adapter.add('dy', function (dy, target) {
      if (target.y === target.parent.maxHeight) {
        return columnMargin;
      }

      return 0;
    });
    labelBullet.locationX = 0;
    labelBullet.locationY = 0;
    labelBullet.label.horizontalCenter = 'left';
    labelBullet.label.verticalCenter = 'bottom';
    labelBullet.label.text = '{label}';
    labelBullet.label.paddingTop = 12;
    labelBullet.label.paddingLeft = 12;
    labelBullet.label.paddingBottom = 12;
    labelBullet.label.paddingRight = 12;
    labelBullet.label.truncate = true;
    labelBullet.label.wrap = true;
    labelBullet.label.fullWords = false;
    labelBullet.label.fill = am4core.color(theme.current.colors.text);
    labelBullet.clickable = true;
    labelBullet.label.clickable = true;
    var labelHitEvent = labelBullet.events.on('hit', function (ev) {
      if (!ev.target.dataItem) {
        return;
      }

      columnTemplate.dispatchImmediately('hit', ev);
    });
    var labelOverEvent = labelBullet.events.on('over', function (ev) {
      if (!ev.target.dataItem) {
        return;
      }

      var columns = chart.series.getIndex(0).columns.values;
      var column = columns.find(function (col) {
        return col.dataItem.dataContext.dataContext.id === ev.target.dataItem.dataContext.dataContext.id;
      });

      if (!column) {
        return;
      }

      column.isHover = true;
    });
    return function () {
      labelHitEvent.dispose();
      labelOverEvent.dispose();
    };
  }, [chart, config.tooltipText]);
  return (0, _themeUi.jsx)("div", {
    sx: {
      position: 'relative'
    }
  }, (0, _themeUi.jsx)("div", _extends({}, props, {
    id: chartId,
    sx: {
      width: '100%',
      height: 13,
      '& text': {
        variant: 'textStyles.caption'
      }
    }
  })), loading && (0, _themeUi.jsx)(_components.Spinner, {
    sx: {
      position: 'absolute',
      color: 'primaryLight',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }));
};

FilterTreeMapChart.propTypes = {
  chartId: _propTypes["default"].string.isRequired,
  onClickFilter: _propTypes["default"].func,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    label: _propTypes["default"].string,
    value: _propTypes["default"].number,
    active: _propTypes["default"].bool
  })),
  loading: _propTypes["default"].bool,
  config: _propTypes["default"].shape({
    tooltipText: _propTypes["default"].string
  })
};
FilterTreeMapChart.defaultProps = {
  onClickFilter: null,
  data: [],
  loading: false,
  config: {
    tooltipText: '{label}: [bold]{value}[/]'
  }
};
var _default = FilterTreeMapChart;
exports["default"] = _default;